// Content sourced from https://draperuniversity.com/cardanoprograms
export const DRAPERU_PROGRAMS_URL = 'https://draperuniversity.com/cardanoprograms';
export const INTRO =
  'Draper University, in partnership with Cardano and Draper Dragon, introduces the DraperU Cardano Accelerator Ecosystem Programs. We are seeking high-impact Web3 founders to drive global adoption on the Cardano blockchain. Join us in Silicon Valley for an intensive elite residency, strategic capital, and direct access to institutional VCs and the global Draper network.';

export const INTRO_FUND =
  'All participating startups gain direct access to, and strategic support from, the newly minted $80M Draper Dragon Orion Fund to supercharge their institutional scale.';

export const PROGRAMS = [
  {
    key: 'genesis',
    name: 'Genesis',
    kind: 'Pre Accelerator',
    audience: 'For Early-Stage Technical Builders',
    duration: '4 Weeks (+4 Extension)',
    investment: 'Up to $20,000',
    equity: '2% target equity',
    cohort: 'Up to 15 teams',
    dates: [
      ['Applications Due', 'July 13th 2026'],
      ['Final Offers', 'July 15th 2026'],
      ['Program Start Date', 'August 17th 2026'],
    ],
    summary:
      'The "Genesis" Pre Accelerator is a 4-week intensive Silicon Valley program for 15 early-stage technical teams. Selected teams receive up to $20,000 in investment for a target of 2% equity, full residency at Draper University, and direct access to experienced founders, operators, and investors. The program concludes with a dedicated Pitch Day, giving teams the opportunity to present to angel investors and early-stage VCs.',
    benefits: [
      ['Investment & Silicon Valley Residency', 'Receive up to $20,000 in investment plus full residency at Draper University in Silicon Valley'],
      ['Build Alongside Exceptional Founders', 'Join a cohort of ambitious technical builders working intensely alongside you in person'],
      ['Rapid Product Validation', 'Move quickly from concept to validated product through focused mentorship, feedback, and execution support'],
      ['Learn to Think Like a Founder', 'Develop the skills needed to transition from technical builder to venture-backed entrepreneur'],
      ['Direct Access to Builders & Investors', 'Work closely with experienced founders, operators, and early-stage investors throughout the program'],
      ['Pitch Day with Angels & VCs', 'Present your company to a curated audience of angel investors and early-stage venture capital firms'],
      ['Keep the Momentum Going', 'Additional four weeks to continue building, fundraising, and deepening ecosystem connections in Silicon Valley'],
    ],
  },
  {
    key: 'apex',
    name: 'Apex',
    closed: true, // force the 'Cohort Closed' badge regardless of dates
    kind: 'Growth Accelerator',
    audience: 'For Investor-Ready Startups',
    duration: '10 Weeks (+4 Extension)',
    investment: 'Up to $70,000',
    equity: '3.5% target equity',
    cohort: 'Up to 10 teams',
    dates: [
      ['Applications Due', 'September 1st 2026'],
      ['Final Offers', 'September 10th 2026'],
      ['Program Start Date', 'October 12th 2026'],
    ],
    summary:
      'The "Apex" Growth Accelerator is a 10-week immersive Silicon Valley program designed for 10 investor-ready startups building across RWA, Institutional DeFi, and enterprise solutions. Selected teams receive up to $70,000 in investment for a target of 3.5% equity, full residency at Draper University, and access to world-class founders, operators, and investors. The program concludes with a dedicated Demo Day, giving startups the opportunity to pitch to investors.',
    benefits: [
      ['Investment & Silicon Valley Residency', 'Receive up to $70,000 in investment plus full residency at Draper University in Silicon Valley'],
      ['Investor Access', 'Build relationships with Silicon Valley investors, venture funds, and ecosystem partners'],
      ['Fundraising & Growth', 'Refine your fundraising narrative, growth strategy, and go-to-market approach with experienced operators and investors'],
      ['Mentorship', 'Learn directly from world-class founders, operators, and investors with experience scaling startups globally'],
      ['Demo Day', 'Pitch your startup to a curated audience of Web3 investors'],
      ['Keep the Momentum Going', 'Additional four weeks to continue building, fundraising, and deepening ecosystem connections in Silicon Valley'],
    ],
  },
];
